import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
	root: {
		"& >div": {
			marginBottom: "16px",
		},
	},
});

const TariffsList = ({ datatest, children }) => {
	const classes = useStyles();
	return (
		<div className={classes.root} datatest={datatest}>
			{children}
		</div>
	);
};

export default TariffsList;
